"use client";

import React, { useState, useRef, useEffect } from "react";
import { ArrowRight, CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function DesignDasKonvertiert() {
  const sectionRef = useRef<HTMLElement>(null);
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  const handleMouseMove = (e: React.MouseEvent<HTMLElement>) => {
    if (!sectionRef.current) return;
    const {
      left,
      top,
      width,
      height
    } = sectionRef.current.getBoundingClientRect();
    const x = (e.clientX - left) / width - 0.5;
    const y = (e.clientY - top) / height - 0.5;
    setMousePosition({
      x,
      y
    });
  };
  const handleMouseLeave = () => {
    setMousePosition({
      x: 0,
      y: 0
    });
  };
  const rotateX = mousePosition.y * -15;
  const rotateY = mousePosition.x * 15;
  return <section data-section-id="15857" id="logistik-ohne-umwege" ref={sectionRef} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} className="dark bg-slate-950 text-slate-50 relative min-h-[90vh] flex items-center overflow-hidden perspective-1000 ![padding:80px_16px_80px_-20px] ![margin:0px_0px_0px_-15px]">
      {}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-[-20%] left-[-10%] w-[70%] h-[70%] bg-blue-600/20 rounded-full blur-[120px] animate-pulse mix-blend-screen" />
        <div className="absolute bottom-[-20%] right-[-10%] w-[60%] h-[60%] bg-slate-800/20 rounded-full blur-[120px] animate-pulse mix-blend-screen delay-1000" />
        <div className="absolute top-[40%] left-[40%] w-[40%] h-[40%] bg-blue-500/10 rounded-full blur-[100px] animate-pulse mix-blend-screen delay-2000" />
        
        {}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(59,130,246,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(59,130,246,0.05)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_at_center,black_40%,transparent_80%)]" />
      </div>

      <div className="container mx-auto relative z-10 grid lg:grid-cols-12 gap-12 items-center">
        {}
        <div className="lg:col-span-7 flex flex-col gap-8 text-center lg:text-left">
          <div className="space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-sm bg-blue-600/10 border border-blue-600/30 text-blue-500 text-xs font-mono tracking-widest uppercase w-fit mx-auto lg:mx-0 backdrop-blur-sm">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-500 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
              </span>
              Premium Logistik Lösungen
            </div>
            <h1 className="text-5xl sm:text-6xl lg:text-8xl font-serif font-black uppercase tracking-tighter leading-[0.95]">OHNE UMWEGE ANS ZIEL!</h1>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold uppercase tracking-tighter leading-[0.95] mt-4">SCHNELL, SICHER, UNSCHLAGBAR.</h2>
            
            <p className="text-xl text-slate-400 max-w-2xl mx-auto lg:mx-0 leading-relaxed font-medium">Wir bewegen Ihr Gut mit industrieller Präzision. Von zeitkritischen Express-Sendungen, bis zum Umzug von Privat- oder Geschäftsräumen – direkt, sicher und ohne Umwege.</p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start items-center">
            <Button asChild size="lg" className="h-14 px-8 text-lg bg-blue-600 text-white hover:bg-blue-700 transition-all duration-300 hover:scale-105 hover:shadow-[0_0_40px_-5px_rgba(37,99,235,0.6)] border-0 rounded-sm font-bold uppercase tracking-tight">
              <Link to="/ContactRequestPage">
                Sofort-Anfrage starten 
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            
            <div className="flex items-center gap-6 text-xs font-mono uppercase tracking-wider text-slate-500">
              <div className="flex items-center gap-2">
                <CircleCheck className="h-4 w-4 text-blue-600" />
                <span>Ohne Umladung</span>
              </div>
              <div className="flex items-center gap-2">
                <CircleCheck className="h-4 w-4 text-blue-600" />
                <span>Sorgfaltsgarantie</span>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="lg:col-span-5 relative perspective-[2000px] group">
          <div className="relative w-full aspect-[4/3] transition-transform duration-100 ease-out will-change-transform" style={{
          transform: `rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`
        }}>
            {}
            <div className="absolute inset-0 bg-gradient-to-tr from-blue-600/20 to-slate-800/20 blur-[60px] -z-10 rounded-full opacity-60 group-hover:opacity-80 transition-opacity duration-500" />

            {}
            <div className="relative h-full w-full rounded-sm border border-white/5 bg-slate-900/40 backdrop-blur-md shadow-2xl overflow-hidden ring-1 ring-white/5">
              {}
              <div className="h-8 w-full border-b border-white/5 bg-slate-900/60 flex items-center px-4 gap-2">
                <div className="h-2.5 w-2.5 rounded-full bg-slate-700/50" />
                <div className="h-2.5 w-2.5 rounded-full bg-slate-700/50" />
                <div className="h-2.5 w-2.5 rounded-full bg-slate-700/50" />
                <div className="ml-4 h-4 w-1/2 rounded-full bg-white/5" />
              </div>

              {}
              <div className="relative h-[calc(100%-2rem)] w-full bg-black/40 p-1">
                 <img src="https://erzwerk-logistik.de/wp-content/uploads/2026/05/ChatGPT-Image-12.-Mai-2026-08_36_38.png" data-wvc-srcset="https://erzwerk-logistik.de/wp-content/uploads/2026/05/ChatGPT-Image-12.-Mai-2026-08_36_38.png-wvc-srcset" data-wvc-sizes="https://erzwerk-logistik.de/wp-content/uploads/2026/05/ChatGPT-Image-12.-Mai-2026-08_36_38.png-wvc-sizes" alt="Sprinter 3.5t transport" className="w-full h-full object-cover rounded-sm opacity-80 hover:opacity-100 transition-opacity duration-500 grayscale-[0.3] hover:grayscale-0" />
                
                {}
                <div className="absolute -right-6 top-1/4 p-4 rounded-sm bg-slate-900/90 backdrop-blur-xl border border-blue-600/30 shadow-2xl animate-bounce [animation-duration:3s]" style={{
                transform: `translateZ(40px)`
              }}>
                  <div className="flex items-center gap-3">
                    <div className="h-10 w-10 rounded-sm bg-blue-600/20 flex items-center justify-center text-blue-500">
                      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                      </svg>
                    </div>
                    <div>
                      <div className="text-[10px] font-mono text-slate-500 uppercase tracking-widest">Pünktlichkeit</div>
                      <div className="text-lg font-black text-white">100%</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}